import "./SelectBox.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import Api from "../../api/Api";
import { useInViewport } from "react-in-viewport";
import { TitleContext } from "../../context/TitleContext";
import removeSelected from "../../assets/images/icons/removeSelected.svg";
import { Button } from "react-bootstrap";

export const SelectBox = (props) => {
  const [show, setShow] = useState(false);
  const [venue, setVenue] = useState("Choose a location...");
  const [venues, setVenues] = useState([]);
  const [venueOptions, setVenueOptions] = useState([]);
  const [venueName, setVenueName] = useState("");
  const [venueAddress, setVenueAddress] = useState("");

  const [page, setPage] = useState(1);
  const size = 10;
  const [query, setQuery] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const myRef = useRef();
  const { inViewport } = useInViewport(myRef);
  const { setTitle } = useContext(TitleContext);

  const handleDropdown = () => {
    setShow(!show);
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (venue === "Choose a location...") {
      Api.getVenues(page, size, query).then((res) => {
        setVenues([...venues, ...res?.data]);
        initOptions([...venues, ...res?.data]);
        setHasMore(res?.extra);
      });
    }
  }, [page, size, venue]);

  useEffect(() => {
    setPage(1);
    let timer = setTimeout(() => {
      Api.getVenues(1, size, query).then((res) => {
        setVenues(res?.data);
        initOptions(res?.data);
        setHasMore(res?.extra);
      });
    }, 750);
    return () => clearTimeout(timer);
  }, [query]);

  const onQueryChange = (e) => {
    const { value } = e.target;
    setQuery(value);
    document.getElementById("venues-list").scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setTitle("SELECT YOUR LOCATION");
  }, []);

  const initOptions = (venueList) => {
    const venueArray = [];
    if (venueList) {
      venueList.forEach((venue, index) => {
        if (venue.name) {
          venueArray.push(
            <label className="venue" index={venue._id}>
              <input
                hidden
                readOnly
                value={venue?._id}
                text={venue?.name}
                className="w-100"
                onClick={(e) => {
                  handleChange(e);
                  setVenueName(venue?.name);
                  setVenueAddress(venue?.fullAddress);
                }}
              />
              <p className="w-100  select-venue-title">{venue?.name}</p>
              <p className="w-100 venue-full-address ps-0">
                {venue?.fullAddress}
              </p>
            </label>
          );
        }
      });
      setVenueOptions(venueArray);
    }
  };

  const handleChange = (e) => {
    setVenue(e.target.attributes["text"].nodeValue);
    props.onVenueChange(e.target.value.toString());
  };

  const removeSelectedVenue = (e) => {
    setVenue("Choose a location...");
    props.onVenueChange("");
  };

  useEffect(() => {
    setShow(false);
  }, [venue]);

  const onVenueListScroll = (e) => {
    if (inViewport && hasMore) {
      setPage(page + 1);
      e.target.scrollTop = e.target.scrollTop - e.target.scrollTop / (page + 1);
    }
  };

  return (
    <>
      {venue !== "Choose a location..." && (
        <div className="removable-selected-venue">
          <div className="selected-details">
            <p className="venue-name">{venueName}</p>
            <p className="venue-address">{venueAddress}</p>
          </div>
          <img
            src={removeSelected}
            onClick={removeSelectedVenue}
            className="removable-icon"
            alt="removable-icon"
          />
        </div>
      )}
      {venue === "Choose a location..." && (
        <div className="venue-select-dropdown" onClick={handleDropdown}>
          <div className="custom-venue-select">
            <input className="venue-select-desc" readOnly value={venue} />
            {/* <hr className="venue-hr" /> */}

            <div className="select-box-arrow"></div>
            <div className="select-box" hidden={!show}>
              <div className="search-bar">
                <span className="search-icon" hidden={query !== ""}></span>
                <input
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  type="text"
                  className="venue-search-box "
                  placeholder="Search..."
                  onChange={(e) => {
                    e.stopPropagation();
                    onQueryChange(e);
                  }}
                />
              </div>
              <div
                id="venues-list"
                className="venues-list"
                onScroll={onVenueListScroll}
              >
                {venueOptions}
                <div className="text-white" ref={myRef} hidden={!hasMore}>
                  Show More...
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="text-center">
        <Button
          className="cc-button venue-btn"
          onClick={() => {
            props.submitForm();
          }}
        >
          Enter
        </Button>

        <h2
          className="title"
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "24px" }}
        >
          Can’t find the location you’re looking for?
        </h2>
        <p
          className="custom-select-venue-desc venue-choose-option mb-0"
          onClick={() => {
            props.askLocation();
          }}
          hidden={props.locationDenied}
        >
          Show me my nearest locations
        </p>
      </div>
    </>
  );
};
